// extracted by mini-css-extract-plugin
module.exports = {"container":"MerchandiserForm_container__32s37","submit":"MerchandiserForm_submit__33w3K"};